import { YearlySummary } from '@/components/gamification/YearlySummary';
import { TripErrorBoundary } from '@/utils/errorBoundary';

export default function YearlySummaryRoute() {
  return (
    <TripErrorBoundary name="GamificationYearlySummary">
      <YearlySummary />
    </TripErrorBoundary>
  );
}
